import React from "react";
import { useNavigate } from "react-router-dom";
import { Dropdown, Tooltip } from "antd";
import { EllipsisOutlined } from "@ant-design/icons";
import { equipmentUseMutation } from "../hooks";
import EquipmentConst from "../equipment-const";
import { EntityRemoveButton, Localize } from "components/service";
import { localizeByKey, localizeByKeyStatic } from "components/service/localize";
import { TEquipment } from "../helpers/equipment-types-helper";
import Icons from "components/icons";
import { usePermissionByObject, useModelFormValidation } from "components/permissions";
import Equipment from "components/equipment";


interface IEquipmentActionFieldProps
{
  equipment: TEquipment | undefined;
  variables: Record<string, any>;
  language: string;
}


const EquipmentActionField: React.FC<IEquipmentActionFieldProps> = ({ equipment, variables, language }) =>
{
  const navigate = useNavigate();

  const { _setMutationEquipmentDelete, loadingMutationEquipmentDelete } =
    equipmentUseMutation.delete(equipment?.group_id, variables);

  const { hasPermission: hasUpdatePermission } = usePermissionByObject(Equipment.Const.permissions.UPDATE);
  const { hasPermission: hasDeletePermission } = usePermissionByObject(Equipment.Const.permissions.DELETE);
  const { validateDeletePermission } = useModelFormValidation(Equipment.Const);

  const items = [
    {
      label: (
        <Tooltip
          title={!hasUpdatePermission ? `${localizeByKeyStatic('PERMISSION.Error_AccessDenied')}: ${localizeByKeyStatic(Equipment.Const.permissions.UPDATE.slug)}` : undefined}
        >
          <span style={{ display: "flex", alignItems: "center", width: 100 }}>
            <Icons.Edit /> <Localize>MENUS_DROP.Label_Edit</Localize>
          </span>
        </Tooltip>
      ),
      key: "1",
      onClick: () => {
        if (!hasUpdatePermission) return;
        navigate(
          `${EquipmentConst.basePath}/edit/${equipment?.group_id}/${language}`
        );
      },
      disabled: !hasUpdatePermission,
    },
    {
      key: "2",
      label: (
        <Tooltip
          title={!hasDeletePermission ? `${localizeByKeyStatic('PERMISSION.Error_AccessDenied')}: ${localizeByKeyStatic(Equipment.Const.permissions.DELETE.slug)}` : undefined}
        >
          <EntityRemoveButton
            modalButton={
              <span style={{ display: "flex", alignItems: "center", width: 100 }}>
                <Icons.Delete /> <Localize>MENUS_DROP.Label_Delete</Localize>
              </span>
            }
            nameEntity={
              localizeByKey("ENTITY.Modal_Title_Equipment")
            }
            dataNameEntity={equipment?.title}
            loading={loadingMutationEquipmentDelete}
            deleteMutation={(options) =>
            {
              if (!validateDeletePermission()) {
                return Promise.reject(new Error('Access denied'));
              }
              return _setMutationEquipmentDelete(options);
            }}
            variables={{
              group_id: equipment?.group_id,
            }}
          />
        </Tooltip>
      ),
      disabled: !hasDeletePermission,
    },
  ];

  return (
    <Dropdown
      // trigger={['click']}
      placement="bottomRight"
      menu={{ items }}
      overlayClassName="drop-more-menu"
      arrow
    >
      <EllipsisOutlined className="btn-more" />
    </Dropdown>
  );
};

export default EquipmentActionField;
